export const CoreSetupAuditTrailViewsName = 'CoreSetupAuditTrailViews';
